/**
 * Sorts entities with businesses first, then alphabetically by name.
 * Used by EntitiesCell components across different views.
 */
export function sortEntitiesByBusinessThenName<
    T extends { isBusiness: boolean; name: string | null },
>(entities: T[]): T[] {
    return [...entities].sort((a, b) => {
        if (a.isBusiness !== b.isBusiness) {
            return a.isBusiness ? -1 : 1;
        }
        const aName = a.name ?? "";
        const bName = b.name ?? "";
        return aName.localeCompare(bName);
    });
}
